// @flow

const types = {
  APPLICATIONS_START: 'APPLICATIONS_START',
  APPLICATIONS_SUCCESS: 'APPLICATIONS_SUCCESS',
  APPLICATIONS_FAIL: 'APPLICATIONS_FAIL',
};

export default types;
